import { useEffect, useRef } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { isEmpty } from 'ramda';
import Routes from './routes';
import { setLocaleData } from '@wordpress/i18n';
import './assets/scss/theme.scss';
import 'overlayscrollbars/styles/overlayscrollbars.css';

// store
import { useStoreValue, storeSet } from './store';
import { updateExternalDragPosition } from './store/externalDragStore';

// React Query
import { queryClient } from './lib/query-client';

// components
import BlockingOverlay from './components/BlockingOverlay';
import DragGhost from './components/DragGhost';

function App() {
    const role = useStoreValue('getRole');
    const token = useStoreValue('token');
    const isLoadingUserData = useStoreValue('getUserLoading');
    const lastUserToken = useRef('');

    useEffect(() => {
        // Fetch user data when token changes
        if (!isEmpty(token) && lastUserToken.current !== token) {
            lastUserToken.current = token;
            storeSet('fetchUserData');
        }

        // Load localization
        fetch('/languages/en_US.json')
            .then((res) => res.json())
            .then(res => {
                setLocaleData(res.locale_data['soundbetween'], 'soundbetween')
            })
            .catch(err => console.log(err))
    }, [token]);

    useEffect(() => {
        const handleMouseMove = (e) => updateExternalDragPosition(e.clientX, e.clientY);
        document.addEventListener('mousemove', handleMouseMove);
        return () => document.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <DragGhost />
            <BlockingOverlay shouldDisplay={isLoadingUserData} />
            <BrowserRouter>
                <Routes role={role}/>
            </BrowserRouter>
            {/*{process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}*/}
        </QueryClientProvider>
    );
}

export default App;